import React, { useContext } from 'react';
import { HeaderOutput, HeaderActionsCell } from './';
import { RuleType } from '@decisions/server/DecisionsFramework/Design/Flow';
import { RuleOutputDisplayData } from '@decisions/server/DecisionsFramework/Design/Flow/Service';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import { hasActionsColumn } from '../TruthTableUtils';
import { IRootGroupModel } from 'domains/designers/RuleDesigner/models/RootGroupModel';

export interface HeaderOutputCellsProps {
  rootModel: IRootGroupModel;
  onDeleteClick?: (result: RuleOutputDisplayData) => void;
  onEditOutputClick?: (result: RuleOutputDisplayData) => void;
}

export function HeaderOutputCells({ rootModel, onDeleteClick, onEditOutputClick }: HeaderOutputCellsProps) {
  const { isDebug, designerSurface } = useContext(RuleDesignerContext);
  const multipleResults = rootModel.RuleDisplayData.DefaultResults;

  switch (rootModel.RuleDisplayData.RuleType) {
    //TODO alex: is it possible?
    case RuleType.LogicalRule: {
      return <HeaderOutput name={'Result'} />;
    }
    case RuleType.ActionRule: {
      return <HeaderActionsCell />;
    }
    case RuleType.DataReturnRule:
    case RuleType.MultipleDataRule:
    case RuleType.MultipleDataRuleValueOutput:
      return (
        <>
          {multipleResults.map(output => {
            const canChange = rootModel.canChangeOutputData && !isDebug;
            const canDelete = canChange && rootModel.RuleDisplayData.RuleType !== RuleType.DataReturnRule;
            return (
              <HeaderOutput
                key={`${output.DisplayName}-${output.Index}`}
                name={output.DisplayName}
                canEdit={canChange}
                canRemove={canDelete}
                onDeleteClick={() => onDeleteClick?.(output)}
                onEditClick={() => onEditOutputClick?.(output)}
              />
            );
          })}
          {hasActionsColumn(rootModel, designerSurface) && <HeaderActionsCell />}
        </>
      );
  }
}
